module.exports = new __parcel__URL__("Productie.cb2f7830.jpg").toString();